import { NavigationModal } from '@bridebook/web/app-basic/components/navigation-modal/navigation-modal';
import {
  BridebookLogoSpriteIcon,
  HeaderSvgSprite,
} from '@bridebook/web/app-basic/components/header/header-svg-sprite';
import TopBarLoggedOutButtons from '@bridebook/web/app-basic/components/top-bar-logged-out-buttons/top-bar-logged-out-buttons';
import { FC, memo, useCallback, useState } from 'react';
import { cn } from '@bridebook/aura';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { BB_LOGO_SIZE } from '@bridebook/web/app-shared/lib/ui/constants';

interface IProps {
  isSticky?: boolean;
  isInvert?: boolean;
}

const TopBarComponent: FC<IProps> = ({ isSticky, isInvert }) => {
  const market = useMarket();
  const [isNavigationModalOpen, setIsNavigationModalOpen] = useState(false);
  const toggleNavigationModal = useCallback(() => {
    setIsNavigationModalOpen((open) => !open);
  }, []);

  return (
    <header>
      <HeaderSvgSprite />
      <div className={cn('bca', isInvert && 'bca-invert')}>
        <Link href={`/${market.prefix}`}>
          <BridebookLogoSpriteIcon
            className="bblogo"
            width={BB_LOGO_SIZE}
            // calculate height from the viewBox
            height={Math.round((BB_LOGO_SIZE * 23.3) / 176.6)}
            viewBox="0 0 176.6 23.3"
          />
        </Link>
        <TopBarLoggedOutButtons onBurgerClick={toggleNavigationModal} />
      </div>
      <NavigationModal isSticky={isSticky} isOpen={isNavigationModalOpen} />
    </header>
  );
};

export const TopBar = memo(TopBarComponent);
